// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3Jdqj","sendOtp":"AuthorizeToLogin_sendOtp__B_lrJ"};